"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageManager = void 0;
const storage_1 = require("firebase/storage");
/**
 * Storage Service Manager
 * Handles Firebase Storage initialization for file storage operations
 */
class StorageManager {
    constructor() {
        this.storage = null;
        this.initialized = false;
    }
    initialize(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.initialized && this.storage) {
                return this.storage;
            }
            try {
                console.log('💾 StorageManager: Initializing Firebase Storage...');
                this.storage = (0, storage_1.getStorage)(app);
                this.initialized = true;
                console.log('✅ StorageManager: Storage service initialized');
                return this.storage;
            }
            catch (error) {
                console.error('❌ StorageManager: Failed to initialize Storage:', error);
                throw error;
            }
        });
    }
    getInstance() {
        return this.storage;
    }
    getStorage() {
        if (!this.storage) {
            throw new Error('Storage not initialized. Call initialize() first.');
        }
        return this.storage;
    }
    isInitialized() {
        return this.initialized && this.storage !== null;
    }
    /**
     * Reset manager for testing purposes
     */
    reset() {
        this.storage = null;
        this.initialized = false;
    }
}
exports.StorageManager = StorageManager;
